/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Ai_2Inputs */

const da_privacy_ai_2 = /** @type {(inputs: Privacy_Ai_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det samme gælder, når du beder AI om at læse en konverteringstabel, lave et udkast til en rettevejledning eller vurdere klassens resultater (indsatsområder). Til vurderingen sendes kun statistik og betegnelser som »Elev 7«, aldrig aliasser.`)
};

/** @type {(inputs: Privacy_Ai_2Inputs) => LocalizedString} */
const en_privacy_ai_2 = da_privacy_ai_2;

/**

* @param {Privacy_Ai_2Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_ai_2 = /** @type {((inputs?: Privacy_Ai_2Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Ai_2Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_ai_2(inputs)
	return /** @type {LocalizedString} */ ("Det samme gælder, når du beder AI om at læse en konverteringstabel, lave et udkast til en rettevejledning eller vurdere klassens resultater (indsatsområder). Til vurderingen sendes kun statistik og betegnelser som »Elev 7«, aldrig aliasser.")
});